<template>
<div class="modal fade" id="modalConfirmCancelSlugReservation" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-card card">
                <div class="card-header">
                    <div class="row align-items-center">
                        <div class="col">
                            <h4 class="card-header-title">
                                Cancelar miniatura
                            </h4>
                        </div>
                        <div class="col-auto">
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="card-body">
                    <p>Tens a certeza de que queres cancelar a reserva da miniatura {{ namespace }}<b>{{ slug }}</b>?</p>

                    <div class="row">
                        <div class="col-6">
                            <BaseButton data-dismiss="modal">
                                Manter a reserva
                            </BaseButton>
                        </div>
                        <div class="col-6">
                            <BaseButton :status="buttonStatus" @click="cancelSlugReservation()">
                                Cancelar a reserva
                            </BaseButton>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { required } from 'vuelidate/lib/validators'

import store from '@/store/store'

export default {
    props: {
        namespace: {
            type: String
        },
        slug: {
            type: String
        }
    },
    computed: {
        ...mapGetters({
            pending: 'api/isPending'
        }),
        isSlugCancelationPending() {
            // get api status for button feedback
            return this.pending('cancelSlugCreation')
        },
        buttonStatus() {
            return this.isSlugCancelationPending ? 'loading' : 'default'
        }
    },
    methods: {
        async cancelSlugReservation () {
            try {
                await store.dispatch('api/cancelCreateSlug', { slug: this.slug })

                await store.dispatch('dashboard/removeLocalUrl', {
                    slug: this.slug
                }, { root: true })

                $('#modalConfirmCancelSlugReservation').modal('hide')
            } catch (err) {
                console.log(err)
            }
        }
    }
};
</script>

<style lang="css" scoped>
</style>
